import { createContext } from 'react';

export type FilterMenuOption = {
    /** Stable identity — what `FilterMenuSelection` stores. */
    value: string;
    label: string;
    /** Result count previewed behind the option. */
    count?: number;
};

export type FilterMenuCategory = {
    key: string;
    label: string;
    options: FilterMenuOption[];
    /** One option at a time, shown as checks rather than checkboxes. */
    single?: boolean;
};

/** Selected option values per category key. Empty categories are dropped. */
export type FilterMenuSelection = Record<string, string[]>;

export type FilterMenuContextValue = {
    categories: FilterMenuCategory[];
    draft: FilterMenuSelection;
    toggleValue: (categoryKey: string, value: string) => void;
    clearDraft: () => void;
    applyDraft: () => void;
    /** The draft differs from the applied selection — `Anwenden` is meaningful. */
    isDirty: boolean;
    /** Anything selected in the draft at all — `Alle entfernen` is meaningful. */
    hasSelection: boolean;
    /** Category on level 2; `undefined` means level 1. */
    activeCategoryKey: string | undefined;
    /** The last category drilled into, so level 2 keeps it while sliding out. */
    exitingCategoryKey: string | undefined;
    openCategory: (categoryKey: string | undefined) => void;
};

export const FilterMenuContext = createContext<FilterMenuContextValue | undefined>(undefined);
